<template>
  <div class="home">
    <ul class="filters">
      <li>
        <a
          v-on:click="showActive"
          v-bind:class="{ selected: filter === 'active' }"
          >Active</a
        >
      </li>
      <!-- <li>
        <a
          v-on:click="showDelivered"
          v-bind:class="{ selected: filter === 'delivered' }"
          >Delivered</a
        >
      </li> -->
      <li>
        <a
          v-on:click="showOrdered"
          v-bind:class="{ selected: filter === 'ordered' }"
          >Ordered</a
        >
      </li>
      <li>
        <a
          v-on:click="showReserved"
          v-bind:class="{ selected: filter === 'reserved' }"
          >Reserved</a
        >
      </li>
      <li>
        <a
          v-on:click="showIssues"
          v-bind:class="{ selected: filter === 'issues' }"
          >Issues</a
        >
      </li>
    </ul>
    <div class="data-table" id="orders-table">
      <div class="header">
        <div>ID</div>
        <div>Company</div>
        <div>Contact</div>
        <div>Items</div>
        <div>Amount</div>
        <div>Created At</div>
        <div>Delivered At</div>
        <div>Status</div>
      </div>
      <div
        v-for="cart in carts"
        v-bind:key="cart.id"
        class="row"
      >
        <div class="cell">
          <b>{{cart.code}}</b><br />
          <router-link :to="{ name: 'cartPage', params: { id: cart.id } }">{{cart.id}}</router-link>
        </div>
        <div class="cell">
          {{(companies[cart.companyId] || {}).name}}
        </div>
        <div class="cell">
          {{getContactInfo(cart)}}
        </div>
        <div class="cell">
          {{cart.items.map(i => i.jobId)}}
        </div>
        <div class="cell">
          {{(cart.items.reduce((p, n) => p + n.price.total, 0) / 100).toFixed(2)}}
        </div>
        <div class="cell">
          {{new Date(cart.createdAt._seconds * 1000).toLocaleDateString()}}
        </div>
        <div class="cell">
          {{cart.items[0].deliveredAt ? new Date(cart.items[0].deliveredAt._seconds * 1000).toLocaleDateString() : null}}
        </div>
        <div class="cell" style="padding-bottom: 0">
          {{cart.status}}
        </div>
      </div>
    </div>
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<style scoped lang="less">
#orders-table {
  grid-template-columns: auto auto auto auto auto auto auto auto
}
table {
  border-collapse: collapse;
  width: 100%;
  td, th {
    border: 1px solid gray;
    padding: 2px;
    width: 12.5%;
  }
}
</style>

<script>
import api from "../services/api";

export default {
  name: "home",
  data: function() {
    return {
      carts: [],
      allCarts: [],
      companies: {},
      filter: 'purchased'
    };
  },
  async created() {
    this.allCarts = await api.getCarts();
    this.companies = (await api.getCompanies()).reduce(
      (v1, v2) => {
        v1[v2.id] = v2;
        return v1;
      },
      {}
    );
    this.navigate(this.$route);
  },
  methods: {
    getContactInfo(cart) {
      if (cart.contactDetails) {
        return cart.contactDetails.firstName + ' ' + cart.contactDetails.phoneNumber;
      }
    },
    showPurchased() {
      document.title = 'Purchased/Carts';
      this.carts = this.allCarts.filter(s => s.status === 'purchased');
      this.$router
        .push({ name: "carts", query: { filter: "purchased" } })
        .catch(() => {});
      this.filter = 'purchased';
    },
    showDelivered() {
      document.title = 'Delivered/Carts';
      this.carts = this.allCarts.filter(s => s.status === 'delivered');
      this.$router
        .push({ name: "carts", query: { filter: "delivered" } })
        .catch(() => {});
      this.filter = 'delivered';
    },
    showOrdered() {
      document.title = 'Ordered/Carts';
      this.carts = this.allCarts.filter(s => s.status === 'ordered');
      this.$router
        .push({ name: "carts", query: { filter: "ordered" } })
        .catch(() => {});
      this.filter = 'ordered';
    },
    showIssues() {

    },
    showReserved() {
      document.title = 'Reserved/Carts';
      this.carts = this.allCarts.filter(s => s.status === 'reserved');
      this.$router
        .push({ name: "carts", query: { filter: "reserved" } })
        .catch(() => {});
      this.filter = 'reserved';
    },
    showActive() {
      document.title = 'Active/Carts';
      this.carts = this.allCarts.filter(s => (s.status === 'purchased' || s.status === 'delivered') );
      this.$router
        .push({ name: "carts", query: { filter: "active" } })
        .catch(() => {});
      this.filter = 'active';
    },
    navigate(route) {
      const filter = route.query.filter;
      if (filter === "reserved") {
        this.showReserved();
      } else if (filter === "active") {
        this.showActive();
      } else if (filter === "ordered") {
        this.showOrdered();
      } else {
        this.showActive();
      }
    }
  }
};
</script>
